import React from 'react';
import { StaticPageHeader } from '../components/StaticPageHeader';
import { Footer } from '../components/Footer';

export const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      <StaticPageHeader />
      
      {/* Add padding top to account for fixed header */}
      <div className="pt-16">
        {/* Content */}
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Cookie Policy</h1>
          <p className="text-gray-600 mb-8">Effective Date: July 1, 2026</p>

          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 mb-6">
              This Cookie Policy explains how DriveHR uses cookies and similar technologies to recognize you when you visit our website.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">1. What Are Cookies?</h2>
            <p className="text-gray-700 mb-6">
              Cookies are small data files stored on your browser or device that help us enhance your experience.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">2. How We Use Cookies</h2>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-6">
              <li>Understand site usage and visitor behavior</li>
              <li>Remember preferences and login sessions</li>
              <li>Track marketing performance and ad effectiveness</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">3. Types of Cookies</h2>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-6">
              <li><strong>Essential:</strong> Required for basic site functionality</li>
              <li><strong>Performance:</strong> Track website usage (e.g., Google Analytics)</li>
              <li><strong>Targeting:</strong> Deliver relevant marketing content and measure ad performance, including through the Meta (Facebook) Pixel, which helps us understand which ads lead to visits and sign-ups.</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">4. Your Choices</h2>
            <p className="text-gray-700 mb-6">
              You may choose to disable cookies in your browser. However, some features of the site may not function properly.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">5. Contact</h2>
            <p className="text-gray-700 mb-6">
              Questions? Email <a href="mailto:help@drive-hr.com" className="text-blue-600 hover:underline">help@drive-hr.com</a>.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};